<script>
    export default {
        props: {
            count: {
                type: Number,
                required: true
            },
            total: {
                type: Number,
                required: true
            },
            to: {
                type: Object,
                default: null
            }
        },
        computed: {
            more () {
                return this.total - this.count
            }
        },
        render (createElement) {
            return createElement(this.to ? 'router-link' : 'div', {
                class: [
                    'inline-flex',
                    'items-center',
                    'justify-center',
                    'no-underline',
                    'text-inherit',
                    ...(this.to ? ['hover:text-blue'] : [])
                ].join(' '),
                attrs: {
                    to: this.to
                }
            }, [
                createElement('span', {}, `+ ${this.more} more`),
                createElement('base-svg', {
                    class: [
                        'w-4',
                        'h-4',
                        'fill-current'
                    ].join(' '),
                    attrs: {
                        name: 'icon-cheveron-right'
                    }
                })
            ])
        }
    }
</script>
